/* PWW v74: send wheel Show all to tighter size-prefixed search results. */
(function () {
  var groupedClass = 'pww-fitment-duplicate-hidden';
  var processedAttr = 'data-pww-grouped-products-ready';
  var finishWords = 'black gloss matte satin machined milled bronze gold silver chrome gunmetal anthracite gray grey red blue white polished painted clear coat dark light tinted double carbon titanium diamond cut brushed beadlock beadlocks';
  var finishWordsPattern = new RegExp('\\b(?:' + finishWords.replace(/\s+/g, '|') + ')\\b', 'g');

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/[“”]/g, '"')
      .replace(/[^a-z0-9.+/"-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function finishFromTitle(title, model, sizeText) {
    return normalizeText(title)
      .replace(model, ' ')
      .replace(sizeText, ' ')
      .replace(/\b\d+\s*x\s*\d{3}(?:\.\d+)?\s*(?:mm)?/g, ' ')
      .replace(/\b(?:et|offset)\s*[-+]?\d+\b/g, ' ')
      .replace(/\b(?:cb|hub|bore|center bore|centre bore)\s*[:/-]?\s*\d+(?:\.\d+)?\s*(?:mm)?\b/g, ' ')
      .replace(/\b\d+(?:\.\d+)?\s*(?:mm)?\s*(?:cb|hub|bore|center bore|centre bore)\b/g, ' ')
      .replace(/\b\d+(?:\.\d+)?\s*mm\b/g, ' ')
      .replace(/\b(?:wheel|wheels|rim|rims|sale|cad)\b/g, ' ')
      .replace(/\b\d+(?:\.\d+)?\b/g, ' ')
      .replace(/\.+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function specParts(title) {
    var normalized = normalizeText(title);
    var sizeMatch = normalized.match(/\b(\d{2})\s*x\s*(\d+(?:\.\d+)?)\b/);
    var tireMatch = normalized.match(/\b\d{3}\/\d{2}r\d{2}\b/i);
    var size = '';

    if (sizeMatch) size = sizeMatch[1];
    if (tireMatch) size = tireMatch[0].toUpperCase();

    var finish = normalized
      .replace(/\b\d{2}\s*x\s*\d+(?:\.\d+)?\b/g, ' ')
      .replace(/\b\d{3}\/\d{2}r\d{2}\b/gi, ' ')
      .replace(/\b\d+\s*x\s*\d{3}(?:\.\d+)?\s*(?:mm)?/g, ' ')
      .replace(/\b(?:et|offset)\s*[-+]?\d+\b/g, ' ')
      .replace(/\b(?:cb|hub|bore|center bore|centre bore)\s*[:/-]?\s*\d+(?:\.\d+)?\s*(?:mm)?\b/g, ' ')
      .replace(/\b\d+(?:\.\d+)?\s*(?:mm)?\s*(?:cb|hub|bore|center bore|centre bore)\b/g, ' ')
      .replace(/\b\d+(?:\.\d+)?\s*mm\b/g, ' ')
      .replace(/\b\d{2,3}[a-z]\b/g, ' ')
      .replace(/\b(?:wheel|wheels|rim|rims|tire|tires|sale|cad)\b/g, ' ')
      .replace(/\b\d+(?:\.\d+)?\b/g, ' ')
      .replace(/\.+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    return { size: size, finish: finish };
  }

  function cleanModelText(value) {
    return normalizeText(value)
      .replace(/\b(?:wheel|wheels|rim|rims|fast wheels|project wheel works)\b/g, ' ')
      .replace(/\b\d+\s*x\s*\d{3}(?:\.\d+)?\s*(?:mm)?\b/g, ' ')
      .replace(/\b\d+(?:\.\d+)?\s*mm\b/g, ' ')
      .replace(/\s*\/\s*/g, ' ')
      .replace(/[^a-z0-9-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function removeFinishWords(value) {
    return cleanModelText(value)
      .replace(finishWordsPattern, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function finishWordsFromText(value) {
    var matches = cleanModelText(value).match(finishWordsPattern);
    if (!matches) return '';
    return matches.join(' ');
  }

  function wheelGroupParts(item, title) {
    var normalized = normalizeText(title);
    var sizeMatch = normalized.match(/\b(\d{2})\s*x\s*(\d+(?:\.\d+)?)\b/);
    if (!sizeMatch) return null;

    var sizeText = sizeMatch[0];
    var model = cleanModelText(normalized.slice(0, sizeMatch.index));
    if (!model) return null;

    var modelFamily = removeFinishWords(model) || model;
    var image = imageKey(item);
    var finish = finishWordsFromText(model) || finishFromTitle(normalized, model, sizeText);
    var familyKey = ['wheel-family', modelFamily, sizeMatch[1]].join('|');

    return {
      familyKey: familyKey,
      exactKey: finish ? ['wheel-title', modelFamily, sizeMatch[1], finish].join('|') : '',
      fallbackKey: image ? ['wheel-image', modelFamily, sizeMatch[1], image].join('|') : familyKey,
      searchText: [modelFamily, sizeMatch[1] + 'x'].filter(Boolean).join(' '),
      finish: finish
    };
  }

  function tireGroupKey(title) {
    var normalized = normalizeText(title);
    var sizeMatch = normalized.match(/\b\d{3}\/\d{2}r\d{2}\b/i);
    if (!sizeMatch) return '';

    var model = normalized.slice(0, sizeMatch.index).replace(/\b(?:tire|tires)\b/g, ' ').replace(/\s+/g, ' ').trim();
    if (!model) return '';

    return [model, sizeMatch[0].toUpperCase()].join('|');
  }

  function tireSearchText(title) {
    var normalized = normalizeText(title);
    var sizeMatch = normalized.match(/\b\d{3}\/\d{2}r\d{2}\b/i);
    if (!sizeMatch) return normalized;

    var model = normalized.slice(0, sizeMatch.index).replace(/\b(?:tire|tires)\b/g, ' ').replace(/\s+/g, ' ').trim();
    return [model, sizeMatch[0].toUpperCase()].filter(Boolean).join(' ');
  }

  function listingType() {
    var path = window.location.pathname.toLowerCase();
    var title = document.title.toLowerCase();
    if (path.indexOf('/collections/') !== 0) return '';
    if (path.indexOf('wheel') !== -1 || path.indexOf('rim') !== -1 || title.indexOf('wheel') !== -1 || title.indexOf('rim') !== -1) return 'wheel';
    if (path.indexOf('tire') !== -1 || title.indexOf('tire') !== -1) return 'tire';
    return '';
  }

  function getCardTitle(item) {
    if (item.dataset.pwwProductTitle) return item.dataset.pwwProductTitle;
    var link = item.querySelector('.card__heading a, .full-unstyled-link');
    return link ? link.textContent : '';
  }

  function imageKey(item) {
    var src = item.dataset.pwwProductImageSrc || '';
    if (!src) {
      var img = item.querySelector('.card__media img');
      src = img ? (img.currentSrc || img.src || '') : '';
    }
    return src.split('?')[0].replace(/_(?:\d+x|small|medium|large|master)\./i, '.').toLowerCase();
  }

  function fallbackGroupKey(item, type, title) {
    var parts = specParts(title);
    var image = imageKey(item);
    if (!image || !parts.size) return '';
    if (type === 'tire') return ['image', image, parts.size].join('|');
    return ['image', image, parts.size, parts.finish].filter(Boolean).join('|');
  }

  function searchUrl(query) {
    return '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query);
  }

  function addToGroup(groups, searches, key, item, query) {
    if (!key || key.length < 6) return;
    if (!groups[key]) groups[key] = [];
    if (query && !searches[key]) searches[key] = query;
    groups[key].push(item);
  }

  function groupGrid(grid) {
    var type = listingType();
    if (!type || !grid || grid.getAttribute(processedAttr) === 'true' || grid.dataset.pwwGroupingExpanded === 'true') return;

    var groups = {};
    var groupSearches = {};
    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid__item'));

    if (type === 'wheel') {
      var wheelEntries = [];
      var familyFinishes = {};

      items.forEach(function (item) {
        var title = getCardTitle(item);
        var parts = wheelGroupParts(item, title);
        var fallback = fallbackGroupKey(item, type, title);
        if (!parts && (!fallback || fallback.length < 6)) return;

        if (parts) {
          wheelEntries.push({ item: item, parts: parts });
          if (!familyFinishes[parts.familyKey]) familyFinishes[parts.familyKey] = {};
          if (parts.finish) familyFinishes[parts.familyKey][parts.finish] = true;
        } else {
          addToGroup(groups, groupSearches, fallback, item, title);
        }
      });

      wheelEntries.forEach(function (entry) {
        var knownFinishes = Object.keys(familyFinishes[entry.parts.familyKey] || {});
        var key = entry.parts.familyKey;

        if (knownFinishes.length > 1) {
          key = entry.parts.exactKey || entry.parts.fallbackKey;
        }

        if (!key || key.length < 6) return;
        addToGroup(groups, groupSearches, key, entry.item, entry.parts.searchText);
      });
    } else {
      items.forEach(function (item) {
        var title = getCardTitle(item);
        var key = tireGroupKey(title);
        if (!key || key.length < 6) key = fallbackGroupKey(item, type, title);
        addToGroup(groups, groupSearches, key, item, tireSearchText(title));
      });
    }

    Object.keys(groups).forEach(function (key) {
      var items = groups[key];
      if (items.length < 2) return;

      var first = items[0];
      var info = first.querySelector('.card-information') || first.querySelector('.card__information');
      if (!info || first.querySelector('.pww-fitment-group-note')) return;

      for (var i = 1; i < items.length; i += 1) {
        items[i].classList.add(groupedClass);
        items[i].hidden = true;
      }

      var note = document.createElement('div');
      note.className = 'pww-fitment-group-note';
      note.innerHTML = '<span>' + items.length + (type === 'tire' ? ' tire options' : ' wheel fitments') + ' available</span><button type="button">Show all</button>';
      note.querySelector('button').addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

        var query = groupSearches[key];
        if (query) {
          window.location.href = searchUrl(query);
          return;
        }

        grid.dataset.pwwGroupingExpanded = 'true';
        items.forEach(function (item) {
          item.classList.remove(groupedClass);
          item.hidden = false;
        });
        note.remove();
      });
      info.appendChild(note);
    });

    grid.setAttribute(processedAttr, 'true');
  }

  function groupAllGrids() {
    document.querySelectorAll('#product-grid, .product-grid').forEach(function (grid) {
      groupGrid(grid);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', groupAllGrids);
  } else {
    groupAllGrids();
  }

  document.addEventListener('shopify:section:load', groupAllGrids);
  document.addEventListener('facet:updated', groupAllGrids);

  var observer = new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) { return mutation.addedNodes.length; })) {
      mutations.forEach(function (mutation) {
        var targetGrid = mutation.target && mutation.target.closest ? mutation.target.closest('#product-grid, .product-grid') : null;
        if (targetGrid && !targetGrid.querySelector('.pww-fitment-group-note')) {
          targetGrid.removeAttribute(processedAttr);
          delete targetGrid.dataset.pwwGroupingExpanded;
        }
      });
      window.requestAnimationFrame(groupAllGrids);
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
